// @flow

import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getUserRequest: null,
  getUserSuccess: ['user'],
  updateMeUserSuccess: ['user'],
  getUserError: ['error'],
  clearUser: null,

  changePasswordRequest: ['password', 'newPassword'],
  changePasswordSuccess: ['user'],
  changePasswordError: ['error']
})

export const MeUserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  error: undefined,
  fetching: false,
  userInfo: undefined,
  isUpdated: false,
  updating: false
})

/* ------------- Reducers ------------- */

export const userRequest = (state: Object) => state.merge({
  fetching: true,
  userInfo: undefined,
  isUpdated: false,
  error: undefined
})

export const userSuccess = (state: Object, {user}: Object) => {
  localStorage.setItem("providerId", user.providerUUID)
  return state.merge({
    fetching: false,
    error: undefined,
    isUpdated: false,
    userInfo: user
  })
}

export const processUpdateMeUser = (state: Object, {user}: Object) => {
  let {userInfo} = state
  const {name, fullName, campaign} = user

  let userObj = Object.assign({}, userInfo, {name, fullName, campaign})

  return state.merge({
    fetching: false,
    error: undefined,
    isUpdated: false,
    userInfo: userObj
  })
}

export const userError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  isUpdated: false,
  userInfo: undefined
})

export const clearUser = (state: Object) => INITIAL_STATE

export const resetPasswordRequest = (state: Object) => state.merge({
  fetching: true,
  updating: true,
  isUpdated: false,
  error: undefined
})

export const resetPasswordSuccess = (state: Object, {user}: Object) => state.merge({
  fetching: false,
  isUpdated: true,
  updating: false,
  error: undefined
})

export const resetPasswordError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  isUpdated: false,
  updating: false,
  error
})

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_USER_REQUEST]: userRequest,
  [Types.GET_USER_SUCCESS]: userSuccess,
  [Types.GET_USER_ERROR]: userError,
  [Types.UPDATE_ME_USER_SUCCESS]: processUpdateMeUser,
  [Types.CLEAR_USER]: clearUser,

  [Types.CHANGE_PASSWORD_REQUEST]: resetPasswordRequest,
  [Types.CHANGE_PASSWORD_SUCCESS]: resetPasswordSuccess,
  [Types.CHANGE_PASSWORD_ERROR]: resetPasswordError
})
